export default __webpack_public_path__ + "static/media/Capture1.d34af269.PNG";